import type { ItemType } from 'antd/es/menu/interface';
import { SetStateAction, useContext } from 'react';

import { CodeMethod } from '@page/explorer/components/code-method/code-method';
import { ExplorerContext } from '@page/explorer/explorer.provider';
import { ExplorerMenuInterface } from '@page/explorer/interface/explorer-menu.interface';
import { DropdownClassName, Select } from '@style/global-style.app';

import Logo from '@asset/logo.icon.svg?react';
import { Text, Title } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

import {
  ExplorerGroupTitle,
  ExplorerMenu,
  ExplorerMenuGroupWrapper,
  ExplorerMenuTitleWrapper,
  ExplorerMenuWrapper,
  ExTitle,
  LogoWrapper,
  SelectWrapper,
} from './aside-explorer.style';

interface AsideExplorerProps {
  menu: ExplorerMenuInterface[];
  onClick: (res: { key: SetStateAction<string> }) => void;
  selectKey: string;
}

export const AsideExplorer = ({ menu, onClick, selectKey }: AsideExplorerProps) => {
  const { applications, currentApplication, setCurrentApplication } = useContext(ExplorerContext);

  return (
    <ExplorerMenuWrapper>
      <LogoWrapper>
        <Logo />
        <ExTitle>explorer</ExTitle>
      </LogoWrapper>
      <SelectWrapper>
        {applications.length > 0 && (
          <Select
            options={applications}
            placeholder='Select Application'
            popupClassName={DropdownClassName}
            size='large'
            value={currentApplication}
            isBlack
            onChange={(value) => setCurrentApplication(value as string)}
          />
        )}
        <Text color={ColorEnum.Black3} level='m'>
          Send HTTP requests and view examples without writing code or setting up an environment.Select a section and
          subsection to get started.
        </Text>
      </SelectWrapper>
      <ExplorerMenu
        mode='inline'
        selectedKeys={[selectKey]}
        items={menu.map(
          (item) =>
            ({
              key: item.id,
              label: (
                <ExplorerMenuGroupWrapper>
                  <ExplorerGroupTitle>{item.name}</ExplorerGroupTitle>
                </ExplorerMenuGroupWrapper>
              ),
              children: item.children.map((child) => ({
                key: child.id,
                label: (
                  <ExplorerMenuTitleWrapper>
                    <Title color={ColorEnum.Black20} level={6} weight={400}>
                      {child.name}
                    </Title>
                    <CodeMethod method={child.method} small />
                  </ExplorerMenuTitleWrapper>
                ),
              })),
            }) as ItemType,
        )}
        onClick={onClick}
      />
    </ExplorerMenuWrapper>
  );
};
